//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Heading from '@/components/Heading'
import Button from '@/components/Button'

export default {
  name: 'Header',

  components: {
    Heading,
    Button
  },

  props: {
    title: String,
    subtitle: String,
    hideButtons: Boolean
  }
}
